import {
  CheckCircleIcon,
  XMarkIcon,
  InformationCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux";
import { alertClose } from "../../features/alert.slice";

const style = {
  colors: {
    primary: {
      bg: `bg-blue-100 `,
      text: `text-blue-500`,
      button: `bg-blue-100 text-blue-500 hover:bg-blue-100  focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-blue-50`,
      icon: (
        <InformationCircleIcon
          className="h-5 w-5 text-blue-500"
          aria-hidden="true"
        />
      ),
    },
    success: {
      bg: `bg-green-100 `,
      text: `text-green-500`,
      button: `bg-green-100 text-green-500 hover:bg-green-100  focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50`,
      icon: (
        <CheckCircleIcon
          className="h-5 w-5 text-green-500"
          aria-hidden="true"
        />
      ),
    },
    danger: {
      bg: `bg-red-100 `,
      text: `text-red-500`,
      button: `bg-red-100 text-red-500 hover:bg-red-100  focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50`,
      icon: <XCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />,
    },
    warning: {
      bg: `bg-yellow-100 `,
      text: `text-yellow-500`,
      button: `bg-yellow-100 text-yellow-500 hover:bg-yellow-100  focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-yellow-50`,
      icon: (
        <ExclamationTriangleIcon
          className="h-5 w-5 text-yellow-500"
          aria-hidden="true"
        />
      ),
    },
  },
};

export type AlertProps = {
  color: "primary" | "success" | "danger" | "warning";
  text: string;
  sbuText?: string;
  onClick?: (event: any) => void;
};

export const Alerts = ({
  color,
  text,
  sbuText,
  onClick = undefined,
}: AlertProps) => {
  const dispatch = useDispatch();
  const alertColor = style.colors[color];
  setTimeout(function(){ dispatch(alertClose()); }, 5000);
  return (
    <div className={`fixed z-50 top-0 left-0 w-full`}>
      <div className={`flex rounded-md ${alertColor.bg} p-4 m-3`}>
        <div className="flex-shrink-0">{alertColor.icon}</div>
        <div className="ml-3">
          <p className={`text-sm font-bold ${alertColor.text}`}>{text}</p>
          <p className={`text-sm ${alertColor.text}`}>{sbuText}</p>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            {onClick === undefined ? (
              <button
                type="button"
                onClick={() => {
                  dispatch(alertClose());
                }}
                className={`p-1.5 inline-flex rounded-md focus:outline-none focus:ring-2 ${alertColor.button}`}
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
